<template>
    <v-ons-page>
      <p style="text-align: center">
        Welcome home.
      </p>
    </v-ons-page>
</template>

<script>
  export default {
    props: ['toggleMenu']
  }
</script>



// WEBPACK FOOTER //
// homePage.vue?fa3d9a3a